import angular from 'angular';
import uiRouter from 'angular-ui-router';
import citiesComponent from './cities.component';
import dataTable from 'angular-material-data-table';

let citiesModule = angular
  .module('cities', [uiRouter, dataTable])

  .config($stateProvider => {
    'ngInject';
    $stateProvider.state('cities', {
      url: '/cities',
      component: 'cities',
      parent: 'main',
      data: {
        permissions: {
          only: ['ADMIN'],
          redirectTo: 'home'
        }
      },
      resolve: {}
    });
  })
  .component('cities', citiesComponent).name;

export default citiesModule;
